import { LoadableUserSettingsNav, metaOSUserSettingsRoutesForLeftNav } from '@ms/yammer-user-settings-page';
import type { FC, ReactNode } from 'react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { DefaultLeftNav } from './DefaultLeftNav';

export interface AppLeftNavProps {
  readonly collapsedOverlayNav?: ReactNode;
  readonly userProfileLinkActionButtons: ReactNode[];
  readonly shouldFocusSearch?: boolean;
  readonly requestSearchFocus?: () => void;
  readonly consumeSearchFocus?: () => void;
}

export const AppLeftNav: FC<AppLeftNavProps> = ({
  collapsedOverlayNav,
  userProfileLinkActionButtons,
  shouldFocusSearch,
  requestSearchFocus,
  consumeSearchFocus,
}) => (
  <Switch>
    <Route exact={true} strict={false} path={metaOSUserSettingsRoutesForLeftNav}>
      <LoadableUserSettingsNav withAppName={true} />
    </Route>
    <Route>
      <DefaultLeftNav
        collapsedOverlayNav={collapsedOverlayNav}
        userProfileLinkActionButtons={userProfileLinkActionButtons}
        shouldFocusSearch={shouldFocusSearch}
        requestSearchFocus={requestSearchFocus}
        consumeSearchFocus={consumeSearchFocus}
      />
    </Route>
  </Switch>
);
